const adjectives = [
  'Happy', 'Clever', 'Bright', 'Swift', 'Quick',
  'Gentle', 'Smart', 'Brave', 'Noble', 'Lucky',
  'Sunny', 'Royal', 'Super', 'Mega', 'Hyper',
  'Grand', 'Fresh', 'Eager', 'Sharp', 'Solid'
];

const nouns = [
  'Tiger', 'Eagle', 'Lion', 'Panda', 'Dolphin',
  'Falcon', 'Dragon', 'Phoenix', 'Unicorn', 'Wolf',
  'Bear', 'Horse', 'Shark', 'Hawk', 'Whale',
  'Fox', 'Owl', 'Seal', 'Deer', 'Duck'
];

const specialChars = ['!', '@', '#', '$', '%', '&', '*'];

/**
 * Generates a password in the format: AdjNoun##!
 * For example: HappyTiger42!
 * 
 * Password requirements:
 * - Starts with an adjective (uppercase first letter)
 * - Followed by a noun (uppercase first letter)
 * - Followed by 2 random digits
 * - Ends with a special character
 */
export function generatePassword(): string {
  // Get random elements
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 90) + 10; // 10-99
  const special = specialChars[Math.floor(Math.random() * specialChars.length)];

  // Combine elements
  return `${adjective}${noun}${number}${special}`;
}

/**
 * Validates if a string matches the generated password format
 */
export function isValidGeneratedPassword(password: string): boolean {
  // Format: AdjNoun##!
  const regex = /^[A-Z][a-z]+[A-Z][a-z]+\d{2}[!@#$%&*]$/;
  return regex.test(password);
}
